import { styled } from '@mui/material';
import { Box } from 'shared/mui/Box';

export const WrapperStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  boxSizing: 'border-box',
  gap: '8px',
});

export const ChartWrapperStyled = styled(Box)({
  height: '8px',
  width: '100%',
  display: 'flex',
});

export const LegendWrapperStyled = styled(Box)({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
});
